/**
 * ReviewForm - leave a star rating and a few words
 * ------------------------------------------------
 * Shown after a chore is marked complete. Both sides get one.
 */

import { useState } from 'react';

import StarRating from './StarRating';
import { reviewApi } from '../services/api';
import { useI18n } from '../hooks/useI18n';

export default function ReviewForm({ choreId, subjectName, onDone }) {
  const { t } = useI18n();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!rating) {
      setError(t('review.chooseStars'));
      return;
    }

    setSaving(true);
    try {
      const result = await reviewApi.create({ chore: choreId, rating, comment });
      if (onDone) onDone(result.review);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="field">
        <span className="label">{t('review.howWasIt', { name: subjectName })}</span>
        <StarRating value={rating} onChange={setRating} />
      </div>

      <div className="field">
        <label htmlFor="review-comment">{t('review.yourReview')}</label>
        <textarea
          id="review-comment"
          value={comment}
          onChange={(event) => setComment(event.target.value)}
          maxLength={1000}
          placeholder={t('review.placeholder')}
        />
        <span className="hint">{comment.length}/1000</span>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <button type="submit" className="btn btn-primary" disabled={saving}>
        {saving ? t('common.saving') : t('review.submit')}
      </button>
    </form>
  );
}
